<template>
  <div class="d-inline mt-1">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          class="ml-2 mr-1"
          v-bind="attrs"
          v-on="on"
          color="primaryDark"
          @click="manageAgenda"
        >
          <v-icon size="14" class="mr-1">mdi-form-select</v-icon>
          {{ $t("agenda.lblManageAgenda") }}
        </a-btn>
      </template>
      <span>{{ $t("agenda.tipManageAgenda") }}</span>
    </v-tooltip>
    <a-dialog v-model="isOpen" width="70vw" persistent scrollable>
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ archiveStatus ? $t("agenda.lblArchive") : $t("agenda.lblManageAgenda") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="isOpen = false" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="padding: 10px 20px 20px 20px">
          <span style="color: #404040" v-if="!archiveStatus">
            {{
              $t("agenda.lblSelectTopic", {
                meetingName:
                  selectedMeeting.meetingName.length > 100
                    ? selectedMeeting.meetingName.slice(0, 85) + "..."
                    : selectedMeeting.meetingName,
                meetingType: selectedMeeting.meetingType,
              })
            }} </span
          ><v-divider class="my-2" v-if="!archiveStatus"></v-divider>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <a-text-field
                      v-model="search"
                      v-on="on"
                      v-bind="attrs"
                      color="neutralGray"
                      filled
                      single-line
                      dense
                      :label="$t('placheHolderAgendaSearch')"
                      value=""
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                      class="mb-3 textField"
                      >
                      <template v-slot:append-outer>
                            <v-btn class="archive-btn" v-if="!archiveStatus" outlined color="primary" large @click="setArchiveStatus(true)">  {{ $t('agenda.lblGoArchive') }}  
                              <v-icon dark right >mdi-arrow-right-bold</v-icon>
                            </v-btn>
                            <v-btn class="archive-btn" v-else outlined color="primary" large @click="setArchiveStatus(false)"> 
                              <v-icon dark left >mdi-arrow-left-bold</v-icon> {{ $t('agenda.lblBackToLive') }}   
                            </v-btn>
                      </template>
                    </a-text-field>
                </template>
                <span v-if="archiveStatus">{{ $t('placheHolderAgendaSearchArchiveTooltip') }} </span>
                <span v-else>{{ $t('placheHolderAgendaSearchLiveTooltip') }} </span>
              </v-tooltip>
              
            </v-col>
          </v-row>
          
          <a-data-table
            :headers="topicHeads"
            :items="unarchiveAgendaTopics"
            class="elevation-1"
            item-key="id"
            :search="search"
            :custom-filter="customFilter"
            :no-data-text="$t('noData')"
            :loading-text="$t('LoaderText')"
            mobile-breakpoint="0"
            height="50vh"
            hide-default-footer
            disable-pagination
            dense
            fixed-header
            :expanded="expandedRow"
            :single-expand="true"
          >
            <template v-slot:[`header.agenda`]="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs"> {{ header.text }} </span>
                </template>
                <span v-html="$t('agenda.tipforAgenda')"></span>
              </v-tooltip>
              &
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs"> {{ $t("Topics") }} </span>
                </template>
                <span v-html="$t('agenda.tipforTopics')"></span>
              </v-tooltip>
              <v-btn icon x-small class="mx-2" @click="openManual()">
                <v-icon color="#ffffff">mdi-alert-circle-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`header.action`]="{ header }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-on="on" v-bind="attrs"> {{ header.text }} </span>
                </template>
                <span v-html="$t('agenda.tipforAction')"></span>
              </v-tooltip>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-card flat v-if="!archiveStatus">
                  <v-card-text class="px-0">
                    <v-form ref="topicForm" v-model="valid" lazy-validation>
                      <add-agenda-topic-details
                        v-model="newTopicForm"
                        @saveTopic="saveNewTopicDetails(item)"
                        @cancel="onCancelAddTopic"
                        :agendaDetail="item"
                        :archivedTopics="meetingValidation.topic_names"
                      ></add-agenda-topic-details>
                    </v-form>
                  </v-card-text>
                </v-card>
              </td>
            </template>
            <template v-slot:[`item.agenda`]="{ item }">
              <v-row no-gutters class="my-2" :id="item.id" :class="`agenda-item-${item.id}`">
                <v-col cols="12" sm="auto">
                    <v-tooltip bottom  max-width="700"  v-if="!archiveStatus">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <v-checkbox
                            id="itemId"
                            hide-details=""
                            :disabled="!item.topics.length"
                            v-model="item.selected"
                            :indeterminate="item.indeterminate"
                            @change="onAgendaSelect(item)"
                          >
                            <template v-slot:label>
                              <h4 class="ml-1">
                               {{ ellipsis(String(item.agendaName || ""), 100) }}
                              </h4>
                            </template>
                          </v-checkbox>
                        </div>
                      </template>
                      <span style="word-wrap: break-word;" v-html="$sanitizeHtml(`<strong>${$t('agenda.tipAgenda')}</strong> <br> ${String(item.agendaName || '')}`)"></span>
                    </v-tooltip>
                  <v-tooltip v-else bottom max-width="700">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <h4 class="ml-1">
                         {{ ellipsis(String(item.agendaName || ""), 100) }}
                        </h4>
                      </div>
                    </template>
                    <span v-html="$sanitizeHtml(`<strong>${$t('agenda.tipAgenda')}</strong> <br> ${String(item.agendaName || '')}`)"></span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                v-for="topic in item.topics"
                :key="topic.Id"
                class="my-2 ml-4"
                :id="`topicId_${topic.Id}`"
                :class="`agenda-tpic-item-${topic.Id}`"
              >
                <v-col cols="12" sm="5">
                  <v-tooltip bottom max-width="700">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-checkbox
                          hide-details=""
                          v-model="topic.selected"
                          :label="topic.topicName"
                          @change="onTopicSelect(item, topic)"
                          :disabled="archiveStatus"
                          :style="{ '--v-checkbox-align-self': 'flex-start' }"
                          class="checkbox-top-align"
                        >
                          <template v-slot:label>
                            <span class="ml-1 overflow-wrap">{{ ellipsis(topic.topicName, 100) }}</span>
                          </template>
                        </v-checkbox>
                      </div>
                    </template>
                    <span style="word-wrap: break-word;" v-html="$sanitizeHtml(`<strong>${$t('topic')}</strong> <br> ${topic.topicName}`)"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="4" class="ml-3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <a-chip
                        v-bind="attrs"
                        v-on="on"
                        small
                        label
                        outlined
                        class="minute"
                        >{{ getTopicCategory(topic.topicCategory) }}</a-chip
                      >
                    </template>
                    <span v-html="$t('agenda.hTopicCategory')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="auto" class="ml-5 text-left">
                  <a-chip small outlined class="minute"
                    >{{ topic.timeInMinutes }} {{ $t("Minutes") }}</a-chip
                  >
                </v-col> 
              </v-row>
              <v-row v-if="!item.topics.length" no-gutters class="my-2 ml-4">
                <span>{{$t('agenda.lblNoTopicsListed')}}</span>
              </v-row>
              <v-row no-gutters class="my-2 ml-4" v-if="!archiveStatus">
                <v-tooltip bottom v-if="item.id !== expandedId">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.id !== expandedId"
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      color="primary"
                      @click="onAddAgendaTopic(item)"
                    >
                      <v-icon small>mdi-plus</v-icon
                      >{{ $t("agenda.btnAddTopic") }}
                    </v-btn>
                  </template>
                  <span> {{ $t("agenda.btnAddTopic") }} </span>
                </v-tooltip>
              </v-row>
            </template>
            <template v-slot:[`item.category`]="{ item }">
              <v-tooltip bottom :disabled="!isEllipsis(item.category, 50)">
                <template v-slot:activator="{ on, attrs }">
                  <a-chip small label outlined class="minute mt-4" v-bind="attrs" v-on="on">{{ ellipsis(item.category, 25) }}</a-chip>
                </template>
                <span v-text="item.category"></span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.priority`]="{ item }">
              <a-chip
                small
                label
                outlined
                class="mt-4"
                :class="getPriorityClass(item.priority)"
                >{{ getPriority(item.priority) }}</a-chip
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
            <div class="my-2" :class="`agenda-action-${item.id}`">
                <v-tooltip bottom v-if="updateAgendaPermission && !archiveStatus">
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-if="updateAgendaPermission && !archiveStatus"
                      class="mr-2"
                      x-small
                      color="primaryDark"
                      width="24"
                      min-width="24"
                      v-bind="attrs"
                      v-on="on"
                      @click="onAgendaEdit(item)"
                    >
                      <v-icon size="16"> mdi-pencil</v-icon>
                    </a-btn>
                  </template>
                  <span v-html="$t('agenda.tipUpdateAgenda')"></span>
                </v-tooltip>
                <v-tooltip bottom v-if="deleteAgendaPermission && !archiveStatus">
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-if="deleteAgendaPermission && !archiveStatus"
                      x-small
                      color="primaryDark"
                      width="24"
                      min-width="24"
                      v-on="on"
                      v-bind="attrs"
                      class="mr-2"
                      @click="onAgendaDelete(item)"
                    >
                      <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                    </a-btn>
                  </template>
                  <span v-html="$t('agenda.tipRemoveAgenda')"></span>
                </v-tooltip>
                <v-tooltip bottom v-if="updateAgendaPermission">
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-if="updateAgendaPermission"
                      class=""
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      width="24"
                      min-width="24"
                      color="primaryDark"
                      elevation="1"
                      @click="archiveAgenda(item)"
                    >
                      <v-icon size="16">mdi-package-down</v-icon>
                    </a-btn>
                  </template>
                  <span v-if="archiveStatus">{{ $t("agenda.tipRevertToLive") }} </span>
                  <span v-else>{{ $t("agenda.lblArchive") }} </span>
                </v-tooltip>
            </div>
              <template v-if="archiveStatus">
              <div
                no-gutters
                v-for="topic in item.topics"
                :key="`actiontopicId_${topic.Id}`"
                class="my-2 text-center"
                :id="`actiontopicId_${topic.Id}`"
                :class="`agenda-tpic-action-item-${topic.Id}`"
                  >
                  <v-tooltip bottom v-if="updateAgendaPermission">
                    <template v-slot:activator="{ on, attrs }">
                        <a-btn
                          v-if="updateAgendaPermission"
                          x-small
                          color="primaryDark"
                          class="ml-0"
                          width="24"
                          min-width="24"
                          v-on="on"
                          v-bind="attrs"
                          @click="unarchiveTopicToLive(topic)"
                        >
                          <v-icon size="16" color="#fff"> mdi-package-up</v-icon>
                        </a-btn>
                    </template>
                    <span v-html="$t('agenda.tipRevertToLive')"></span>
                  </v-tooltip>
                <div style="clear: both;"></div>
              </div>
              </template>
            </template>
          </a-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-tooltip bottom v-if="createAgendaPermission && !archiveStatus">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-if="createAgendaPermission && !archiveStatus"
                class="mr-2"
                :disabled="expandedRow.length > 0"
                color="primary"
                small
                text
                v-bind="attrs"
                v-on="on"
                @click="$emit('openAgendaDialog')"
              >
                <v-icon small>mdi-plus</v-icon>
                <span>{{ $t("agenda.lblAddNewAgenda") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("agenda.lblAddNewAgenda") }} </span> 
            </v-tooltip>
            <span v-if="archiveStatus">
              {{ $t("agenda.msgArchiveCheckBox") }}
            </span>
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="!archiveStatus">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-if="!archiveStatus"
                class="mr-2"
                color="primaryDark"
                :disabled="isDataUnSaved"
                small
                v-bind="attrs"
                v-on="on"
                @click.prevent="addTopics()"
                ><span>{{ $t("lblApply") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("lblApply") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                color="secondary"
                small
                @click="onClose"
                v-bind="attrs"
                v-on="on"
                ><span>{{ $t("btnClose") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnClose") }} </span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
    <confirm-dialog ref="confirm" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchInput from "@/components/SearchInput.vue";
import coloredChipTemplate from "@/components/agenda/coloredChipTemplate.vue";
import { remove, cloneDeep } from "lodash";
import AddAgendaTopicDetails from "./AddAgendaTopicDetails.vue";
import { createUUID } from "../../utils/util";
import MessageSheet from "../MessageSheet.vue";
import ConfirmDialog from "../ConfirmDialog.vue";


export default {
  name: "AgendaTopicSelector",
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
      preAssignedTopics: [],
      selectedTopicIds: [],
      oldSelectedTopicIds: [],
      displayMessage: false,
      messageType: "",
      message: "",
      valid: true,
      newTopicForm: {},
      refNewTopicForm: {
        Id: "",
        agendaId: null,
        topicName: "",
        timeInMinutes: 0,
        topicCategory: "",
        actualTime: 0,
        peopleInCharge: [],
        documents: [],
        memoDescription: "",
      },
      expandedRow: [],
      agendaTopics: [],
      selectedFiles: [1],
      headers: [
        {
          text: "Title",
          value: "name",
          align: "left",
          class: "header",
        },
        {
          text: "Upload Time",
          value: "date",
          align: "left",
          class: "header",
        },
      ],
      search: "",
      agendaItem: {},
      isOpen: false,
      selectedTopics: [],
      addTopicsDisable: false,
      disableTipAssignTopic: false,
      topicCategories: [],
      meetingValidation: {},
      archiveStatus: false,
      stringLength: 80,
    };
  },
  components: {
    SearchInput,
    coloredChipTemplate,
    AddAgendaTopicDetails,
    MessageSheet,
    ConfirmDialog,
  },
  props: {
    selectedMeeting: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.preAssignedTopics = this.meetingObject.topics.map((t) => {
          return t.Id;
        });
        this.oldSelectedTopicIds = cloneDeep(this.preAssignedTopics);
        this.selectedTopicIds = cloneDeep(this.preAssignedTopics);
        this.search = "";
        this.disableTipAssignTopic = true;
        this.expandedRow.pop();
        this.getAgendaTopics();
        if (this.$refs.topicForm) {
          this.$refs.topicForm.resetValidation();
          this.$refs.topicForm.reset();
        }
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      } else {
        this.disableTipAssignTopic = false;
      }
    },
    agendaListData: {
      immediate: true,
      deep: true,
      handler() {
        this.getAgendaTopics();
      },
    },
  },
  mounted() {
    
    this.topicCategories = this.tenantSettingTypes("topiccategory");
    if (this.topicCategories && this.topicCategories.length > 0) {
      this.refNewTopicForm.topicCategory = this.topicCategories[0].id;
    }
    this.$root.$on("add-agenda", (agenda) => {
      this.addNewAgenda(agenda);
    });
    this.$root.$on("manage-agenda-dialog", (value) => {
      this.isOpen = value;
    });
    window.addEventListener("keydown", this.handleKeydown);

  },
  updated() {
    this.syncDivHeights();
  },
  beforeDestroy() {
    this.$root.$off("add-agenda");
    this.$root.$off("manage-agenda-dialog");
  },
  computed: {
    ...mapState({
      agendaListData: (state) => state.agenda.agendaListByMeetingType,
      agendaListWithArchive: (state) => state.agenda.agendaListWithArchive,
    }),
    ...gettersMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    priorities() {
      return [
        {
          text: this.$t("agenda.lblHigh"),
          value: "High",
        },
        {
          text: this.$t("agenda.lblMedium"),
          value: "Medium",
        },
        {
          text: this.$t("agenda.lblLow"),
          value: "Low",
        },
      ];
    },
    isDirty() {
      return (
        JSON.stringify(this.oldSelectedTopicIds) !==
        JSON.stringify(this.preAssignedTopics)
      );
    },
    isDataUnSaved() {
      return this.expandedRow.length > 0 || !this.isDirty;
    },
    expandedId() {
      return this.expandedRow.length > 0
        ? this.expandedRow[0]["id"]
        : "not found";
    },
    meetingObject: {
      get() {
        return this.selectedMeeting;
      },
      set(val) {
        this.selectedMeeting = val;
      },
    },
    topicHeads() {
      return [
        {
          text: this.$t("agenda.tipAgenda"),
          align: "start",
          value: "agenda",
          sortable: false,
          groupable: false,
          width: "65%",
          class: "header-text header label-s",
        },
        {
          align: "center",
          text: this.$t("agenda.hCategory"),
          value: "category",
          width: "10%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
        {
          align: "center",
          text: this.$t("agenda.hPriority"),
          value: "priority",
          width: "10%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
        {
          align: "center",
          text: this.$t("agenda.hAction"),
          value: "action",
          width: "12%",
          groupable: false,
          sortable: false,
          class: "header-text header label-s",
        },
      ];
    },
    createAgendaPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "CreateAgenda"
        );
      }
      return false;
    },
    viewMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "ViewMeeting"
        );
      }
      return false;
    },
    updateAgendaPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateAgenda"
        );
      }
      return false;
    },
    deleteAgendaPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "DeleteAgenda"
        );
      }
      return false;
    },
    unarchiveSelectedTopics(){
      return this.agendaListWithArchive.map((agenda) => {
            agenda.topics = agenda.topics.map((obj) => ({
              ...obj,
              selected: this.preAssignedTopics.includes(obj.Id),
            }));
            return agenda;
          });
    },
    unarchiveAgendaTopics: {
        get() {
          // Determine the appropriate list of agenda items
          const agendaListItems = this.archiveStatus ? this.unarchiveSelectedTopics : this.agendaTopics;
          // Filter and map agenda items
          return agendaListItems
            .filter((agenda) => {
              const hasUnarchivedAgenda = agenda.is_archived === undefined || agenda.is_archived === this.archiveStatus;
              const hasUnarchivedTopics = agenda.topics.some(
                (topic) => topic.is_archived === undefined || topic.is_archived === this.archiveStatus
              );
              return hasUnarchivedAgenda || hasUnarchivedTopics;
            })
            .map((agenda) => ({
              ...agenda,
              topics: agenda.topics.filter(
                (topic) => topic.is_archived === undefined || topic.is_archived === this.archiveStatus
              ),
            }));
        },
        set(val) {
          this.agendaTopics = val;
        }
      },
  },
  methods: {
    ...mapActions({
      updateAgendaData: "agenda/updateAgenda",
      getAgendaById: "agenda/getAgendaById",
      getAgendaListByMeetingType: "agenda/getAgendaListByMeetingType",
      getAgendaListWithArchive: "agenda/getAgendaListWithArchive",
      createAgendaData: "agenda/createAgenda",
      getAgendaValidation: "agenda/getAgendaValidation",
      deleteAgenda: "agenda/deleteAgenda",
      updateAgendaData: "agenda/updateAgenda",
    }),
    async manageAgenda(){
      this.isOpen = true
      const filter = {is_archived: true, meeting_type_id: this.getMeetingTypeId} 
      await this.getAgendaListWithArchive(filter);
      this.archiveStatus = false;
    },
    createUUID,
    onAddAgendaTopic,
    saveNewTopicDetails,
    onCancelAddTopic,
    onClose,
    addNewAgenda,
    onAgendaDelete,
    onAgendaEdit,
    updateSelectedTopicIds,
    getAgendaTopics,
    scrollToTopicPosition,
    filterByTopic,
    filterByProperty,
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: "/usermanual",
        query: {
          content:
            this.$i18n.locale == "en"
              ? "Manual_E_Topic Category.pdf"
              : "Meeting.Structure.Sample.pdf",
          id: "TopicCategory",
        },
      });
      let popup;
      if (
        routeData &&
        (typeof this.manualWindow === "undefined" ||
          this.manualWindow.closed ||
          this.manualClick === 1)
      ) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      } else {
        this.manualWindow.focus();
      }
    },
    getPriority(priority) {
      if (priority) {
        let priorityData = this.priorities.filter(
          (obj) => obj.value === priority
        );
        return priorityData.length > 0 ? priorityData[0].text : priority;
      }
    },
    getPriorityClass(text) {
      return String(text).toLowerCase();
    },
    onTopicSelect(item, topic) {
      item.selected = this.isAllTopicSelected(item);
      item.indeterminate = this.isPartiallyTopicSelected(item);
      this.updateSelectedTopicIds(topic.Id);
    },
    isAllTopicSelected(agenda) {
      return agenda.topics.every((t) => t.selected) && agenda.topics.length > 0;
    },
    isPartiallyTopicSelected(agenda) {
      return (
        agenda.topics.some((t) => t.selected) &&
        !this.isAllTopicSelected(agenda)
      );
    },
    onAgendaSelect(item) {
      const agenda = item;
      agenda.topics.forEach((topic) => {
        topic.selected = agenda.selected;
        this.updateSelectedTopicIds(topic.Id);
      });
    },
    scrollToTop() {
      document.getElementById("itemId")?.scrollIntoView({
        behavior: "instant",
        block: "center",
        inline: "nearest",
      });
    },
    customFilter(value, search, item) {
      const searchText = search.toString().toLowerCase();

      if (!item) {
        return false;
      }

      const { agendaName, category, priority, topics } = item;

      return (
        this.filterByProperty(searchText, agendaName) ||
        // this.filterByProperty(searchText, category) ||
        // this.filterByProperty(searchText, priority) ||
        topics.some((topic) => this.filterByTopic(topic, searchText))
      );
    },
    selectedData(item) {
      if (item.length === 0) {
        this.addTopicsDisable = true;
      } else {
        this.addTopicsDisable = false;
      }
      return item;
    },
    addTopics() {
      const selectedUnArchiveTopics = this.agendaTopics.reduce((topic, agenda) => {
        if (agenda.topics) {
          topic = topic.concat(agenda.topics.filter((topic) => topic.selected));
        }
        return topic;
      }, []);

      const selectedArchivedTopics = this.unarchiveSelectedTopics.reduce((topic, agenda) => {
        if (agenda.topics) {
          topic = topic.concat(agenda.topics.filter((topic) => topic.selected));
        }
        return topic;
      }, []);
      const selectedTopics = [...selectedUnArchiveTopics, ...selectedArchivedTopics]

      let topics = this.selectedMeeting.topics;
      let existingTopics = topics
        .filter((s) => selectedTopics.some((t) => s.Id === t.Id))
        .map(({ selected, ...rest }) => {
          return rest;
        });

      let removedTopics = topics.filter(
        (item1) => !selectedTopics.some((item2) => item1.Id === item2.Id)
      );
      this.deleteTopicDocument(removedTopics);
      let maxOrder = 0;
      if (existingTopics.length) {
        maxOrder = Math.max(...existingTopics.map((e) => e.displayOrder));
      }
      let order = ++maxOrder || 1;
      let newAssignTopics = selectedTopics
        .filter((s) => !topics.some((t) => s.Id === t.Id))
        .map(({ selected, ...rest }) => {
          return { ...rest, displayOrder: order++ };
        });
      this.selectedMeeting.topics = existingTopics.concat(newAssignTopics);
      this.onClose();
      this.$emit("onTopicSelection", this.selectedMeeting);
    },
    getAgendaName(id) {
      this.agendaItem = {};
      const agenda = this.agendaListData.find((f) => f.id === id);
      if (agenda) {
        this.agendaItem = agenda;

        return agenda.agendaName;
      }
      return id;
    },
    getAgendaCategoryColor(cat) {
      const category = this.categoriesList.find(
        (c) => String(c.name).toLowerCase() === String(cat).toLowerCase()
      ) || { order: 0, name: cat, color: "#2471A3" };
      return category.color;
    },
    getTopicCategory(topCat) {
      const category = this.topicCategories.find((c) => c.id === topCat) || {
        name: "",
        value: "",
        id: "",
      };
      return category.name;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    deleteTopicDocument,
    async setArchiveStatus(status){
      this.search = ""
      const filter ={is_archived: status, meeting_type_id: this.getMeetingTypeId} 
      await this.getAgendaListByMeetingType(filter);
      this.archiveStatus = status
    },
    async unarchiveTopicToLive(topic) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hRevertToLive"),
          this.$t("agenda.hMsgRevertToLive"),
          {
            yesNoButtons: true,
            removeAgreeBtn: false,
            btnCancel: this.$t("btnCancel"),
          }
        )
      ) {
        const agendaIndex = this.unarchiveAgendaTopics.findIndex(agenda => agenda.id === topic.agendaId);
        if (agendaIndex !== -1) {
          const updatedAgenda = {
            ...this.unarchiveAgendaTopics[agendaIndex],
            topics: this.unarchiveAgendaTopics[agendaIndex].topics.map(item => ({
              ...item,
              is_archived: item.Id !== topic.Id
            }))
          };
          await this.updateAgendaData(updatedAgenda).then(async (response) => {
                  const filter ={is_archived: true, meeting_type_id: this.selectedMeeting.meetingTypeId} 
                  await this.getAgendaListByMeetingType(filter);
                  this.$emit("alert", this.$t("agenda.AgendaCreateSuccess"), "success");
              });
        }
      }
    },
    async archiveAgenda(item){
      let heading = !this.archiveStatus ? this.$t("agenda.hConfirmArchive") : this.$t("agenda.hConfirmUnArchive")
      let message = !this.archiveStatus ? this.$t("agenda.hMsgArchive") : this.$t("agenda.hMsgUnArchive")
      if (
        await this.$refs.confirm.open(
          heading,
          message,
          {
            yesNoButtons: true,
            removeAgreeBtn: false,
            btnCancel: this.$t("btnCancel"),
          }
        )
      ) {
        item.is_archived = !this.archiveStatus;
        item.topics.forEach(topic => {
          topic.is_archived = !this.archiveStatus;
        });
        await this.updateAgendaData(item)
        .then(async (response) => {
          const filter ={is_archived: this.archiveStatus, meeting_type_id: this.selectedMeeting.meetingTypeId} 
          await this.getAgendaListByMeetingType(filter);
          this.$emit("alert", this.$t("agenda.AgendaCreateSuccess"), "success");
        })
        .catch((e) => {
          this.Loaderloading = false;
        })
        .finally(() => (this.Loaderloading = false));

      }
    },
    isEllipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return String(string).length > strlen;
    },
    ellipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return this.isEllipsis(string, length)
        ? string.substring(0, strlen) + "..."
        : string;
    },
    syncHeights(elements, classPrefix, idPrefix = "") {
        elements.forEach((element) => {
          const id = idPrefix ? element.id.replace(idPrefix, "") : element.id;
          const targetClass = `${classPrefix}-${id}`;
          const elementHeight = element.getBoundingClientRect().height;
          const height = elementHeight < 24 ? 24 : elementHeight;
          const targetElement = document.querySelector(`.${targetClass}`);
          if (targetElement) {
            targetElement.style.height = `${height}px`;
          }
        });
      },
    syncDivHeights() {
      this.$nextTick(() => {
      // Sync agenda heights
      const agendaElements = document.querySelectorAll("[class*=agenda-item]");
      this.syncHeights(agendaElements, "agenda-action");

      // Sync topic heights
      const topicElements = document.querySelectorAll("[class*=agenda-tpic-item]");
      this.syncHeights(topicElements, "agenda-tpic-action-item", "topicId_");
    });
    },
    handleKeydown(event) {
      if (event.ctrlKey && ["+", "=", "-", "0"].includes(event.key)) {
        const _this  = this;
        setTimeout(() => {
          _this.syncAllHeights();
      }, 200);
      }
    },

    syncAllHeights() {
      // Sync agenda heights
      const agendaElements = document.querySelectorAll("[class*=agenda-item]");
      this.syncHeights(agendaElements, "agenda-action");
      // Sync topic heights
      const topicElements = document.querySelectorAll("[class*=agenda-tpic-item]");
      this.syncHeights(topicElements, "agenda-tpic-action-item", "topicId_");
    }
  },
};

function deleteTopicDocument(topics) {
  topics.forEach(async (topic) => {
    const documents = topic.documents;
    documents.forEach(async (docment) => {
      this.$eventHub.$emit("onDeleteDocuments", docment.documentId);
    });
  });
}

function filterByProperty(value, property) {
  return property ? property.toString().toLowerCase().includes(value) : false;
}

function filterByTopic(topic, value) {
  return this.filterByProperty(value, topic.topicName);
  // this.filterByProperty(value, topic.timeInMinutes) ||
  // this.filterByProperty(value, this.getTopicCategory(topic.topicCategory))
}

function scrollToTopicPosition(topicId = null) {
  if (topicId) {
    const el = document.getElementById(`topicId_${topicId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  } else {
    if (this.agendaTopics.length) {
      const topics = this.agendaTopics[this.agendaTopics.length - 1].topics;
      if (topics.length) {
        const topicId = topics[topics.length - 1].Id;
        const el = document.getElementById(`topicId_${topicId}`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    }
  }
}

function getAgendaTopics() {
  this.agendaTopics = cloneDeep(this.agendaListData).map((agenda) => {
    agenda.topics = agenda.topics.map((obj) => ({
      ...obj,
      selected: this.preAssignedTopics.includes(obj.Id),
    }));
    return {
      ...agenda,
      selected: this.isAllTopicSelected(agenda),
      indeterminate: this.isPartiallyTopicSelected(agenda),
    };
  });
}

function updateSelectedTopicIds(id) {
  if (!this.preAssignedTopics.includes(id)) {
    this.preAssignedTopics.push(id);
  } else {
    this.preAssignedTopics.splice(this.preAssignedTopics.indexOf(id), 1);
  }
}

async function onAgendaEdit(item) {
  try {
    if (this.viewMeetingPermission) {
      let agendaDetails = await this.getAgendaById(item.id);
      this.$emit("openAgendaDialog", agendaDetails);
    }
  } catch (error) {
    console.error(error);
  }
}

async function onAgendaDelete(data) {
  try {
    const result = await this.getAgendaValidation(data.id);
    if (result.past == true) {
      await this.$refs.confirm.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("agenda.msgPastAgendaTxt", { agendaTitle: data.agendaName }),
        {
          removeAgreeBtn: true,
          btnCancel: this.$t("btnOk"),
        }
      );
    } else if (result.future == true) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.msgFutureAgendaTxt", {
            agendaTitle: data.agendaName,
          }),
          {
            removeAgreeBtn: false,
            yesNoButtons: true,
            btnCancel: this.$t("btnNo"),
          }
        )
      ) {
        if (data) {
          await this.deleteAgenda(data.id);
          this.$emit("removeTopic", data);
          this.showMessageSheet(
            this.$t("agenda.msgAgendaDeletionSuccess"),
            "success"
          );
        }
      }
    } else {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage"),
          {
            removeAgreeBtn: false,
            yesNoButtons: true,
            btnCancel: this.$t("btnCancel"),
          }
        )
      ) {
        if (data) {
          await this.deleteAgenda(data.id);
          this.$emit("removeTopic", data);
          this.showMessageSheet(
            this.$t("agenda.msgAgendaDeletionSuccess"),
            "success"
          );
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
}

async function addNewAgenda(agenda) {
  try {
    agenda.topics.forEach((topic) => {
      const isExist = this.preAssignedTopics.includes(topic.Id);
      
      if (topic.action === "add" || topic.action === "edit") {
        this.preAssignedTopics.push(topic.Id);
      }
    });
    const filter ={is_archived: false, meeting_type_id: this.selectedMeeting.meetingTypeId} 
    await this.getAgendaListByMeetingType(filter);
    if (agenda.topics.length) {
      const topicId = agenda.topics[agenda.topics.length - 1].Id;
      this.$nextTick(() => {
        this.scrollToTopicPosition(topicId);
      });
    }
  } catch (error) {
    console.error(error);
  }
}

async function saveNewTopicDetails(item) {
  try {
    if (this.$refs.topicForm.validate()) {
      if (this.viewMeetingPermission) {
        let agendaDetails = await this.getAgendaById(item.id);
        agendaDetails.topics.push(this.newTopicForm);
        this.updateAgendaData(agendaDetails).then(async () => {
          this.preAssignedTopics.push(this.newTopicForm.Id);
          this.expandedRow.pop();
          this.$nextTick(() => {
            this.scrollToTopicPosition(this.newTopicForm.Id);
          });
          this.showMessageSheet(
            this.$t("agenda.lblTopicAssSuccess"),
            "success"
          );
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

async function onAddAgendaTopic(item) {
  try {
    const result = await this.getAgendaValidation(item.id);
    this.meetingValidation = result;
    this.expandedRow.pop();
    if (this.$refs.topicForm) {
      this.$refs.topicForm.resetValidation();
      this.$refs.topicForm.reset();
    }
    this.$nextTick(() => {
      this.newTopicForm = cloneDeep(this.refNewTopicForm);
      this.newTopicForm.agendaId = item.id;
      this.newTopicForm.Id = createUUID();
      this.expandedRow.push(item);
    });
  } catch (error) {
    console.error(error);
  }
  
}

function onCancelAddTopic() {
  this.expandedRow.pop();
  this.newTopicForm = cloneDeep(this.refNewTopicForm);
}

function onClose() {
  this.isOpen = false;
  this.expandedRow.pop();
}

function gettersMap() {
  return mapGetters({
    categoriesList: "tenant/agendaCategories",
    tenantSettingTypes: "tenant/tenantSettingTypes",
    getMeetingTypeId: "meeting/getMeetingTypeId",
  });
}
</script>
<style scoped>
.checkbox-top-align /deep/ .v-input--selection-controls__input {
  align-self: flex-start; /* Align the checkbox to the top */
  margin-top: 5px;
}
.checkbox-top-align /deep/ .v-label {
  align-items: flex-start; /* Align the label to match the top alignment */
}
.textField /deep/ .v-input__slot {
  height: 42px !important;
}
.checkbox-align {
  vertical-align: top;
}
::v-deep .v-input--selection-controls {
  margin-top: 0px !important;
}
::v-deep td {
  vertical-align: top;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
.archive-btn{
  margin-top: -9px;
}
.overflow-wrap{
  overflow-wrap: anywhere;
}
</style>